import { render, staticRenderFns } from "./emp.vue?vue&type=template&id=aa0f2c0c&scoped=true&"
import script from "./emp.vue?vue&type=script&lang=js&"
export * from "./emp.vue?vue&type=script&lang=js&"
import style0 from "./emp.vue?vue&type=style&index=0&id=aa0f2c0c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0f2c0c",
  null
  
)

component.options.__file = "emp.vue"
export default component.exports